/* ==========================================================================
   Moonou Day/Night — Image toggle with crossfade + iOS-style sliding pill
   Indicator uses CSS custom properties on .moonou-dn__toggle (::before pseudo)
   ========================================================================== */
(function () {
  'use strict';

  // Position indicator via CSS custom properties on toggle (drives ::before)
  function positionIndicator(toggle, btn, animate) {
    if (!animate) {
      toggle.classList.add('moonou-dn__toggle--no-transition');
    }
    toggle.style.setProperty('--ind-left', btn.offsetLeft + 'px');
    toggle.style.setProperty('--ind-width', btn.offsetWidth + 'px');
    toggle.style.setProperty('--ind-height', btn.offsetHeight + 'px');
    if (!animate) {
      toggle.offsetHeight; // force reflow
      toggle.classList.remove('moonou-dn__toggle--no-transition');
    }
  }

  function initSection(section) {
    var toggle = section.querySelector('.moonou-dn__toggle');
    if (!toggle) return;

    var btns = toggle.querySelectorAll('.moonou-dn__btn');
    var imgs = section.querySelectorAll('.moonou-dn__img');

    if (btns.length === 0) return;

    // Position indicator on initial active button (no transition)
    var activeBtn = toggle.querySelector('.moonou-dn__btn[data-active="true"]');
    if (activeBtn) {
      positionIndicator(toggle, activeBtn, false);
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.getAttribute('data-active') === 'true') return;
        var mode = this.getAttribute('data-mode');

        // Update toggle container state (drives background color via CSS)
        toggle.setAttribute('data-state', mode);

        // Update button active states
        btns.forEach(function (b) {
          b.setAttribute('data-active', b.getAttribute('data-mode') === mode ? 'true' : 'false');
        });

        // Crossfade images
        imgs.forEach(function (img) {
          img.setAttribute('data-active', img.getAttribute('data-mode') === mode ? 'true' : 'false');
        });

        // Slide indicator to clicked button
        positionIndicator(toggle, this, true);
      });
    });

    // Store cleanup reference
    section._moonouDnCleanup = function () {};
  }

  function initAll() {
    var sections = document.querySelectorAll('.moonou-dn');
    sections.forEach(function (section) {
      if (section._moonouDnCleanup) {
        section._moonouDnCleanup();
      }
      initSection(section);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-initialize on section load
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.moonou-dn');
    if (section) {
      initSection(section);
    }
  });
})();
